/**
 *  @todo (MON-1688): replace hard coded / hacky utils with BE data
 * gets the date of exactly one year from now
 */
export const aYearFromNow = new Date(
  new Date().setFullYear(new Date().getFullYear() + 1)
).toISOString();
